import { FC } from "react";
import { IconPropsType } from ".";

export const Menu: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_120_389)">
        <path
          d="M1.28587 1.28589H16.7147C17.4246 1.28589 18.0006 1.86133 18.0006 2.57176C18.0006 3.2822 17.4251 3.85764 16.7147 3.85764H1.28587C0.576 3.85764 0 3.2822 0 2.57176C0 1.86133 0.575437 1.28589 1.28587 1.28589Z"
          fill={props.color ?? "#555555"}
        />
        <path
          d="M10.2859 7.71411H16.7147C17.4246 7.71411 18.0006 8.28955 18.0006 8.99999C18.0006 9.71042 17.4251 10.2859 16.7147 10.2859H10.2859C9.576 10.2859 9 9.71042 9 8.99999C9 8.28955 9.57544 7.71411 10.2859 7.71411Z"
          fill={props.color ?? "#555555"}
        />
        <path
          d="M7.71395 14.1429H16.7139C17.4238 14.1429 17.9998 14.7183 17.9998 15.4288C17.9998 16.1392 17.4244 16.7146 16.7139 16.7146H7.71395C7.00407 16.7146 6.42807 16.1392 6.42807 15.4288C6.42807 14.7183 7.00351 14.1429 7.71395 14.1429Z"
          fill={props.color ?? "#555555"}
        />
      </g>
      <defs>
        <clipPath id="clip0_120_389">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
